import Vue from "vue";

const { assign } = Object;
const { transformQuery } = require("../solr");


function buildQueryWithParams(query, offset, limit, facetPrefixes) {
    const { abt, archiv } = facetPrefixes;
    const params = {
        query: query || undefined,
        offset: offset > 0 ? offset : undefined,
        limit: limit != 10 ? limit : undefined,
        sectionFacetPrefixes : abt,
        archiveFacetPrefixes : archiv
    };
    const paramKeys = Object.keys(params)
    const paramsQuery = paramKeys
        .filter(key => typeof params[key] !== "undefined")
        .map(key => [key, params[key]])
        .map(([key, value]) => {
            if(Array.isArray(value)) {
                const sub = [];
                for(const v of value) {
                    sub.push([key, encodeURIComponent(v)].join("="));
                }
                return sub.join("&");
            } else {
                return [key, encodeURIComponent(value)].join("=")
            }
        })
        .join("&");
    return paramsQuery;
}

function executeStateReset(state, payload) {
    const { query } = payload;
    const queryInState = state.query;
    const searchFormMessageBus = state.searchFormMessageBus;
    assign(state, {
        query: "",
        routeQuery: {},
        queryTime: 0,
        total: -1,
        results: [],
        titles: {},
        sections: {},
        volumes: {},
        archives: {},
        searchFormMessageBus
    });
    state.query = (query === undefined) ? queryInState : {q: query};
}

export default {
    namespaced: true,

    // the current state of the last executed query (or blank values, if no query has been executed yet)
    state: {
        searchFormString: "",
        transactions: 0,
        query: "", // the query in Solr notation
        routeQuery: {}, // the query object from this app's route
        queryTime: 0,
        total: -1,
        results: [],
        titles: {},
        sections: {},
        volumes: {},
        archives: {},
        projects: [],
        persons: [],
        searchFormMessageBus: new Vue()
    },

    actions: {
        completeQuery({ dispatch, state }) {
            const { results, total } = state;

            // handle paging
            const offset = results.length;
            const last = total;
            const limit = last - offset;

            dispatch("pagedQuery", { offset, limit });
        },

        async executeQuery({ commit }, { url, routeQuery }) {
            try {
                commit("startTransaction");
                // perform search asynchronously
                const response = await fetch(url, { credentials: "same-origin" });
                const results = await response.json();
                results.routeQuery = routeQuery;
                // store results in this vuex state
                commit("results", results);
            } catch (err) {
                console.log(err);
                commit('reset', {});
            }
            commit("endTransaction");
        },

        newQuery({ commit, dispatch }, route) {
            commit("reset");

            const routeQuery = route.query;
            const transformedQuery = transformQuery(routeQuery);
            const paramsQuery = buildQueryWithParams(transformedQuery.luceneQuery, 0, 10, transformedQuery.facetPrefixes);
            const url = ["/api/search", paramsQuery].filter(c => c).join("?");

            dispatch("executeQuery", { url, routeQuery });
        },

        nextQuery({ dispatch, state }) {

            const { results } = state;

            // handle paging
            const offset = results.length;
            const last = (Math.floor(offset / 10) + 1) * 10;
            const limit = last - offset;

            dispatch("pagedQuery", { offset, limit });
        },

        pagedQuery({ dispatch, state }, { offset, limit }) {

            const { query, routeQuery, total } = state;

            if(!routeQuery.q) {
                return;
            }

            const transformedQuery = transformQuery(routeQuery);

            if (total > 0 && offset >= total) {
                return;
            }

            // build solr search URL
            const paramsQuery = buildQueryWithParams(query, offset, limit, transformedQuery.facetPrefixes);

            const url = ["/api/search", paramsQuery].filter(c => c).join("?");
            dispatch("executeQuery", { url, routeQuery });
        }
    },

    mutations: {
        reset(state, payload={}) {
            executeStateReset(state, payload);
        },

        startTransaction(state) {
            state.transactions += 1;
        },

        endTransaction(state) {
            state.transactions -= 1;
        },

        results(state, {
            query, queryTime, total, results,
            titles, sections, volumes, archives,
            projects, persons, routeQuery
        }) {
            Object.assign(state, {
                query, queryTime, total, titles, volumes, archives, projects, persons, routeQuery, sections
            });
            // transform results into linked list
            if(state.results.length > 0 && results.length > 0) {
                state.results[state.results.length - 1].next = results[0]
                results[0].prev = state.results[state.results.length - 1]
            }

            if(results.length > 1) {
                results[0].next = results[1]
                results[1].prev = results[0]
            }

            for(let i = 1; i < results.length - 1;i++) {
                results[i].next = results[i+1]
                results[i+1].prev = results[i]
            }

            state.results = state.results.concat(results);
        },

        setsearchFormString (state, sfs) {
            state.searchFormString = sfs;
        }
    }
}
